import { formatMoney } from "../money";

// ─── HELPERS ─────────────────────────────────────────────────────────────────

const $ = formatMoney;
const $k = n => {
  const sign = n < 0 ? "-" : "";
  const abs = Math.abs(n);
  return abs >= 1000 ? `${sign}$${(abs/1000).toFixed(1)}k` : `${sign}$${Math.round(abs)}`;
};

export { $, $k };
